import React, { useMemo } from 'react';
import { Table } from 'antd';

import { dynamicPagination } from '../../../utils/common/dynamicPagination';
import { CommonTableProps } from '../../crm/interfaces/common.interface';

export default function UniversalTable<T, F>({
    source,
    loading,
    filters,
    updateFilters,
    getColumns,
    rowKey,
    entityName,
}: CommonTableProps<T, F>) {
    const pagination = useMemo(
        () =>
            dynamicPagination(
                filters,
                updateFilters,
                source?.total,
                entityName
            ),
        [filters, updateFilters, source?.total, entityName]
    );

    return (
        <Table
            scroll={{ x: 900 }}
            rowKey={rowKey}
            dataSource={source.items}
            pagination={pagination}
            loading={loading}
            columns={getColumns()}
        />
    );
}
